var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"app-footer mt-10"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-divider'),_c('div',{staticClass:"mt-5"},[_vm._v("© HRChain, "+_vm._s(_vm.currentYear))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }